// Navigation icons will be moved here by the user
// Examples: LogoutIcon, BackArrowIcon, HomeIcon, etc.
